export default __webpack_public_path__ + "static/media/top.95a87d54.svg";